<ng-container *ngIf="isUpsellVisible">
    <ng-container *ngIf="upsellEvents?.length">
        <div class="upsell-header" (click)="toggle()">
            <div class="upsell-header-title"><span class="icon {{ headerIcon }}"></span>{{ headerTitle }}</div>
            <span class="icon" [ngClass]="{ 'theme-up': isExpanded, 'theme-down': !isExpanded }"></span>
        </div>
        <ng-container *ngIf="isExpanded">
            <ms-scroll-adapter [scrollSize]="303">
                <div class="upsell-list">
                    <bs-upsell-item
                        *ngFor="let upsell of upsellEvents; index as upsellIndex; trackBy: trackByFn"
                        [upsellIndex]="upsellIndex"
                        [upsellEvent]="upsell"></bs-upsell-item>
                    <!-- todo SPO-49960 @Milos this should be checked if needed when acca boost upsell is implemented properly -->
                    <!-- [summary]="betslipSummary"-->
                    <!-- ></bs-upsell-item>-->
                </div>
            </ms-scroll-adapter>
            <div class="see-less">
                <span (click)="seeLessClicked()"> {{ seeLessText }}</span>
            </div>
        </ng-container>
    </ng-container>
</ng-container>
